import React, { Component } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import Image from "../../elements/image";
import "./style.scss";
import Heading from "../../elements/heading";

import classNames from "classnames";

export default class TwoImagesContent extends Component {
  twoImagesContentContent(fields) {
    const { paddingAboveTop, paddingAboveBottom, gridType, backgroundColor, order, image1, image2, headingBody, headingType, body, bulletListItems } = fields;
    let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "default",
      bottom = paddingAboveBottom
        ? paddingAboveBottom.fields.phrase.value
        : "default";
    const twoImagesContentClasses = classNames(
        `two-images-content`,
        "padding-top-" + top,
        "padding-bottom-" + bottom,
        {
          mirrored: (order && order.fields.phrase.value) === "reverse"
        },
        gridType && gridType.fields.phrase.value === "story"
          ? "grid-story"
          : "grid"
      ),
      titleClasses = classNames("title show-on-scroll"),
      media1Classes = classNames("media-1", {
        placeholder: !image1
      }),
      media2Classes = classNames("media-2", {
        placeholder: !image2
      });
    let backgroundStyle = {
      background: backgroundColor
        ? backgroundColor.fields.phrase.value
        : "transparent"
    };
    return (
      <div
        className={twoImagesContentClasses}
        style={backgroundStyle}
        datasourceid={this.props.rendering.dataSource}
      >
        {headingBody && (
          <Heading
            {...{
              type: headingType,
              html: headingBody
            }}
            className={titleClasses}
          />
        )}
        {image1 && image1.value && image1.value.src && (
          <div className={media1Classes}>
            <Image {...image1.value} />
          </div>
        )}

        {body.value && (
          <div className={"body-text"}>
            <RichText field={body} />
          </div>
        )}

        {bulletListItems != null && bulletListItems.length > 0 && (
          <div className={"body-text"}>
            <ul>
              {bulletListItems.map((item, index) => {
                return (
                  <li key={index}>
                    {item.fields.iconName &&
                      item.fields.iconName.value &&
                      item.fields.iconName.value.alt && (
                        <RichText
                          field={{ value: item.fields.iconName.value.alt }}
                        />
                      )}
                    {item.fields.body && item.fields.body.value}
                  </li>
                );
              })}
            </ul>
          </div>
        )}

        {image2 && image2.value && image2.value.src && (
          <div className={media2Classes}>
            <Image {...image2.value} />
          </div>
        )}
      </div>
    );
  }

  render() {
    if (!this.props.fields) return null;
    const { fields } = this.props;
    const { gridType } = fields;
    if ((gridType && gridType.fields.phrase.value) === "story") {
      return (
        <div className={"grid"}>{this.twoImagesContentContent(fields)}</div>
      );
    } else {
      return this.twoImagesContentContent(fields);
    }
  }
}
